import { ComponentType as p } from "../../registries/types/propTypes.js";
const c = (e) => {
  var r;
  const s = [], o = [];
  return (r = e == null ? void 0 : e.timelines) == null || r.forEach((t) => {
    const i = t.events.map((n) => ({
      description: n.description,
      images: n.image.images,
      title: n.title
    }));
    o.push({
      tabId: t.events[0].year,
      data: i
    }), s.push({
      title: t.events[0].year
    });
  }), {
    componentType: p.journey_timelines,
    timelines: {
      tabsData: s,
      tabsContent: o
    },
    activeTabId: e.activeTabId
  };
};
export {
  c as default
};
//# sourceMappingURL=journey-timelines-transformer.js.map
